import {
  HoneymoonDestination,
  HoneymoonDestinationSlug,
  HoneymoonExperienceName,
  HoneymoonSubDestination,
} from 'components/honeymoons/types';

export const HAWAII_DESTINATION: HoneymoonDestination = {
  slug: HoneymoonDestinationSlug.HAWAII,
  key: 'Hawaii',
  description:
    "Just Maui'd? See why Hawaii is such a well-loved honeymoon destination for unwinding and exploring.",
  moreHotelsLink: 'https://sovrn.co/0fal9fy',
  headerImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories_hero/Hawaii.jpg',
  categoryNodeImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories/Hawaii.jpg',
  displayTitle: 'Hawaii',
  experienceCategoryKey: 'LOC_HI',
  linkName: 'in Hawaii',
};

export const CARIBBEAN_DESTINATION: HoneymoonDestination = {
  slug: HoneymoonDestinationSlug.CARIBBEAN,
  key: 'Caribbean',
  description:
    'White sands, clear water, unrivaled resorts… get ready for the most relaxing start to newlywed life.',
  moreHotelsLink: 'https://sovrn.co/c5ks06l',
  linkName: 'in the Caribbean',
  headerImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories_hero/Caribbean.jpg',
  categoryNodeImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories/Caribbean.jpg',
  displayTitle: 'Caribbean Islands',
};

export const ITALY_DESTINATION: HoneymoonDestination = {
  slug: HoneymoonDestinationSlug.ITALY,
  key: 'Italy',
  description:
    "Where to begin? The Amalfi Coast, Tuscany, Lake Como… And we've not even got to Rome or Milan.",
  moreHotelsLink: 'https://sovrn.co/1qyef0q',
  linkName: 'in Italy',
  headerImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories_hero/Italy.jpg',
  categoryNodeImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories/Italy.jpg',
  displayTitle: 'Italy',
};

export const GREECE_DESTINATION: HoneymoonDestination = {
  slug: HoneymoonDestinationSlug.GREECE,
  key: 'Greece',
  description:
    'The birthplace of democracy (and home to the beaches that are the envy of everyone on Instagram).',
  moreHotelsLink: 'https://sovrn.co/6h61haa',
  linkName: 'in Greece',
  headerImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories_hero/Greece.jpg',
  categoryNodeImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories/Greece.jpg',
  displayTitle: 'Greece',
};

export const SPAIN_DESTINATION: HoneymoonDestination = {
  slug: HoneymoonDestinationSlug.SPAIN,
  key: 'Spain',
  description:
    'The buzz of Barcelona. The majesty of Madrid. And the beautiful beaches of Marbella and Mallorca.',
  moreHotelsLink: 'https://sovrn.co/1da7pxv',
  linkName: 'in Spain',
  headerImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories_hero/Spain.jpg',
  categoryNodeImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories/Spain.jpg',
  displayTitle: 'Spain',
};

export const FRANCE_DESTINATION: HoneymoonDestination = {
  slug: HoneymoonDestinationSlug.FRANCE,
  key: 'France',
  description:
    'Paris = the city of love. Need another reason to pick France? How about the glamour of the Riviera?',
  moreHotelsLink: 'https://sovrn.co/1441ut2',
  linkName: 'in France',
  headerImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories_hero/France.jpg',
  categoryNodeImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories/France.jpg',
  displayTitle: 'France',
};

export const MEXICO_CENTRAL_AMERICA_DESTINATION: HoneymoonDestination = {
  slug: HoneymoonDestinationSlug.MEXICO_CENTRAL_AMERICA,
  key: 'Mexico & Central America',
  description:
    'So many decisions at these resorts. Beach day or stay by the pool? And which restaurant for lunch?',
  moreHotelsLink: 'https://sovrn.co/1eewf12',
  linkName: 'in Mexico & Central America',
  headerImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories_hero/Mexico.jpg',
  categoryNodeImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories/Mexico.jpg',
  displayTitle: 'Mexico and Central America',
  nodeTitle: 'Mexico & Central America',
};

export const FLORIDA_KEYS_DESTINATION: HoneymoonDestination = {
  slug: HoneymoonDestinationSlug.FLORIDA_KEYS,
  key: 'Florida Keys',
  description:
    'One of the sunniest places in the U.S., Key West has perfected the art of laid-back living.',
  moreHotelsLink: 'https://sovrn.co/78y07nc',
  linkName: 'in Florida',
  headerImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories_hero/FloridaKeys.jpg',
  categoryNodeImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories/FloridaKeys.jpg',
  displayTitle: 'Florida Keys',
  experienceCategoryKey: 'LOC_MIAMI',
};

export const NAPA_DESTINATION: HoneymoonDestination = {
  slug: HoneymoonDestinationSlug.NAPA,
  key: 'Napa',
  description:
    "There's more to Napa than great wine and food, but it's a pretty good place to start!",
  moreHotelsLink: 'https://sovrn.co/irvj034',
  linkName: 'in Napa',
  headerImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories_hero/NapaV2.jpg',
  categoryNodeImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories/NapaV2.jpg',
  displayTitle: 'Napa, CA',
  experienceCategoryKey: 'LOC_SAN_FRANCISCO',
};

export const CALIFORNIA_COAST_DESTINATION: HoneymoonDestination = {
  slug: HoneymoonDestinationSlug.CALIFORNIA_COAST,
  key: 'California Coast',
  description: 'Give your love story the perfect Hollywood ending with a Californian honeymoon.',
  moreHotelsLink: 'https://sovrn.co/1bwmv6y',
  linkName: 'on the California Coast',
  headerImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories_hero/CaliforniaCoast.jpg',
  categoryNodeImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories/CaliforniaCoast.jpg',
  displayTitle: 'California Coast',
};

export const PARKS_DESTINATION: HoneymoonDestination = {
  slug: HoneymoonDestinationSlug.NATIONAL_PARKS,
  key: 'Parks',
  description: 'Ready for your next adventure? Explore the National Parks, from Acadia to Zion.',
  moreHotelsLink: 'https://sovrn.co/5al0jfs',
  linkName: 'around US Parks',
  headerImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories_hero/NationalPark.jpg',
  categoryNodeImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories/NationalPark.jpg',
  displayTitle: 'National Parks',
  experienceCategoryKey: 'LOC_LAS',
};

export const CHARLESTON_DESTINATION: HoneymoonDestination = {
  slug: HoneymoonDestinationSlug.CHARLESTON,
  key: 'Charleston',
  description:
    'Named the best small city (and friendliest!) in the U.S., Charleston is a romantic gem.',
  moreHotelsLink: 'https://sovrn.co/d0rzxu1',
  linkName: 'in Charleston',
  headerImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories_hero/Charleston.jpg',
  categoryNodeImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories/Charleston.jpg',
  displayTitle: 'Charleston, SC',
  nodeTitle: 'Charleston, SC',
};

export const BALI_DESTINATION: HoneymoonDestination = {
  slug: HoneymoonDestinationSlug.BALI,
  key: 'Bali',
  description:
    'Immerse yourself in the beauty of BalI with its lush vegetation and awe-inspiring temples.',
  moreHotelsLink: 'https://sovrn.co/1gnqq2l',
  linkName: 'in Bali',
  headerImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories_hero/Bali.jpg',
  categoryNodeImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories/Bali.jpg',
  displayTitle: 'Bali',
};

export const MALDIVES_DESTINATION: HoneymoonDestination = {
  slug: HoneymoonDestinationSlug.MALDIVES,
  key: 'Maldives',
  description:
    'One for the Honeymoon Hall of Fame, the Maldives offers the perfect way to relax and rejuvenate.',
  moreHotelsLink: 'https://sovrn.co/xever3q',
  linkName: 'in the Maldives',
  headerImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories_hero/Maldives.jpg',
  categoryNodeImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories/Maldives.jpg',
  displayTitle: 'Maldives',
};

const EUROPE_NAME = 'Europe';
const OTHER_NAME = 'Other';
const CONTINENTAL_US_NAME = 'Continental US';
const VIATOR_NAME = 'Viator';

export const EUROPE_SUBDESTINATION: HoneymoonSubDestination = {
  name: EUROPE_NAME,
  displayTitle: EUROPE_NAME,
  key: 'EUROPE',
  description: 'European Honeymoon destinations',
  moreHotelsLink: 'https://sovrn.co/i5wvr88',
  linkName: 'in Europe',
  categoryNodeImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories/Italy.jpg',
  slug: HoneymoonDestinationSlug.EUROPE,
  destinations: [ITALY_DESTINATION, FRANCE_DESTINATION, SPAIN_DESTINATION, GREECE_DESTINATION],
  experiences: [
    {
      category: EUROPE_NAME,
      partner: VIATOR_NAME,
      displayName: HoneymoonExperienceName.FOOD_DRINK,
      webUrl: 'https://sovrn.co/qxsucc7',
    },
    {
      category: EUROPE_NAME,
      partner: VIATOR_NAME,
      displayName: HoneymoonExperienceName.CRUISES_SAILING,
      webUrl: 'https://sovrn.co/26yhtvy',
    },
    {
      category: EUROPE_NAME,
      partner: VIATOR_NAME,
      displayName: HoneymoonExperienceName.DAY_TRIPS,
      webUrl: 'https://sovrn.co/1g4s3hu',
    },
    {
      category: EUROPE_NAME,
      partner: VIATOR_NAME,
      displayName: HoneymoonExperienceName.EXTREME_SPORTS,
      webUrl: 'https://sovrn.co/0sieptn',
    },
  ],
};

export const OTHER_SUBDESTINATION: HoneymoonSubDestination = {
  name: OTHER_NAME,
  displayTitle: OTHER_NAME,
  key: 'OTHER',
  slug: HoneymoonDestinationSlug.OTHER,
  description: 'Other Honeymoon destinations',
  destinations: [MALDIVES_DESTINATION, BALI_DESTINATION],
  moreHotelsLink: 'https://sovrn.co/lhg3v22',
  linkName: '',
  categoryNodeImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories/Maldives.jpg',
  experiences: [
    {
      category: OTHER_NAME,
      partner: VIATOR_NAME,
      displayName: HoneymoonExperienceName.NATURE_WILDLIFE,
      webUrl: 'https://sovrn.co/1ivqnol',
    },
    {
      category: OTHER_NAME,
      partner: VIATOR_NAME,
      displayName: HoneymoonExperienceName.CRUISES_SAILING,
      webUrl: 'https://sovrn.co/fhngbnk',
    },
    {
      category: OTHER_NAME,
      partner: VIATOR_NAME,
      displayName: HoneymoonExperienceName.EXTREME_SPORTS,
      webUrl: 'https://sovrn.co/12u3ety',
    },
  ],
};

export const CONTINENTAL_US_SUBDESTINATION: HoneymoonSubDestination = {
  name: CONTINENTAL_US_NAME,
  displayTitle: CONTINENTAL_US_NAME,
  categoryNodeImage:
    'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/honeymoon-affiliates/destination_categories/NationalPark.jpg',
  key: 'CONTINENTAL_US',
  description: 'Continental US Honeymoon destinations',
  destinations: [
    FLORIDA_KEYS_DESTINATION,
    CALIFORNIA_COAST_DESTINATION,
    NAPA_DESTINATION,
    CHARLESTON_DESTINATION,
    PARKS_DESTINATION,
  ],
  slug: HoneymoonDestinationSlug.CONTINENTAL_US,
  moreHotelsLink: 'https://sovrn.co/038dg5y',
  linkName: 'in the Continental US',
  experiences: [
    {
      category: CONTINENTAL_US_NAME,
      partner: VIATOR_NAME,
      displayName: HoneymoonExperienceName.NATURE_WILDLIFE,
      webUrl: 'https://sovrn.co/lnkveji',
    },
    {
      category: CONTINENTAL_US_NAME,
      partner: VIATOR_NAME,
      displayName: HoneymoonExperienceName.CRUISES_SAILING,
      webUrl: 'https://sovrn.co/177phta',
    },
    {
      category: CONTINENTAL_US_NAME,
      partner: VIATOR_NAME,
      displayName: HoneymoonExperienceName.DAY_TRIPS,
      webUrl: 'https://sovrn.co/lgjc2k7',
    },
    {
      category: CONTINENTAL_US_NAME,
      partner: VIATOR_NAME,
      displayName: HoneymoonExperienceName.EXTREME_SPORTS,
      webUrl: 'https://sovrn.co/1reroo2',
    },
  ],
};

export const LANDING_PAGE_DESTINATIONS = [
  HAWAII_DESTINATION,
  CARIBBEAN_DESTINATION,
  EUROPE_SUBDESTINATION,
  MEXICO_CENTRAL_AMERICA_DESTINATION,
  CONTINENTAL_US_SUBDESTINATION,
  OTHER_SUBDESTINATION,
];
